import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

import { ContaAppComponent } from "./conta.app.component";
import { ContaRoutingModule } from "./conta.route";
import { LoginComponent } from "./login/login.component";
import { LocalCookiesService } from "./services/local-cookie.service";
import { LoginService } from "./services/login.service";
import { GerenciamentoComponent } from './gerenciamento/gerenciamento.component';
import { ContaService } from "./services/conta.service";
import { jqxWindowModule } from "jqwidgets-ng/jqxwindow";

@NgModule({
    declarations: [
        ContaAppComponent,
        
        LoginComponent,
        GerenciamentoComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ContaRoutingModule,
        jqxWindowModule
    ],
    providers: [CookieService ,LocalCookiesService, LoginService,ContaService],
    exports:[
        
    ]
})
export class ContaModule { }